import DecimalDegreeGrid from './DecimalDegreeGrid';
import DMSGrid from './DMSGrid';
import MGRSGrid from './MGRSGrid';
import UTMGrid from './UTMGrid';

const gridGenerators = {
    'lng|lat|dd': DecimalDegreeGrid,
    'lng|lat|dms': DMSGrid,
    mgrs: MGRSGrid,
    none: () => undefined,
    utm: UTMGrid,
};

export default function getGridMapboxStyle(
    grid: Grid,
    bounds: mapboxgl.LngLatBounds | undefined,
    zoom: number | undefined,
    is3D: boolean
): mapboxgl.Style | undefined {
    if (bounds && zoom && gridGenerators[grid] && !is3D) {
        return gridGenerators[grid](bounds, zoom);
    } else {
        return undefined;
    }
}
